import { render, staticRenderFns } from "./OrganizerMessageModal.vue?vue&type=template&id=728c0d6e&scoped=true"
import script from "./OrganizerMessageModal.vue?vue&type=script&lang=js"
export * from "./OrganizerMessageModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizerMessageModal.vue?vue&type=style&index=0&id=728c0d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c0d6e",
  null
  
)

export default component.exports